<template>
  <transition name="fade">
    <div class="fi-footer">
      <ul class="clearfix">
        <li>
          <h2>关于我们</h2>
          <a href="/aboutus">关于点点</a>
          <a href="/aboutus">点点大事记</a>
          <a href="/aboutus">点点愿景</a>
        </li>
        <li>
          <h2>帮助</h2>
          <p><a href="/helpcenter">帮助中心</a></p>
          <p><a href="https://im2.zhongan.io/zaim/?accessId=1597999116941&tenantID=1514946886000043&color=yellow&themeID=DD001&channelId=94&subject=点点业务&biz=手网">在线咨询</a></p>
          <p><a href="/helpcenter">意见反馈</a></p>
        </li>
        <li>
          <h2>客户服务</h2>
          <p>客服热线：4000666122</p>
          <p>工作日9:00-18:00</p>
        </li>
        <li></li>
      </ul>
      <hr>
      <div class="footer-text">Copyright © 169 2017 - 2018 Diandian 点点版权所有 <a href="https://beian.miit.gov.cn">粤ICP备17079095号</a> 深圳众联商务有限公司</div>
    </div>
  </transition>
</template>
<style lang="scss" scoped>
</style>
<script>
export default {
  data() {
    return {
      footerText:
        "Copyright © 169 2017 - 2018 Diandian 点点版权所有 粤ICP备17079095号-2",
    };
  },
  mounted() {
    if (window.location.host == "www.bepoint.cn") {
      this.footerText =
        "深圳蜂点科技有限公司粤ICP备18073970号-1 <br />地址： 深圳市南山区南山街道南海大道西桂庙路北阳光华艺大厦1栋4楼4D16<br />联系电话：0755-26647844";
    }
  },
  methods: {},
};
</script>



// WEBPACK FOOTER //
// index.vue?e4482fe4